import React, { useEffect, useState, useRef } from "react";
import { FaBars, FaTimes, FaChevronDown, FaMoon, FaSun } from "react-icons/fa";
import Images from "../assets/Image";
import { Link } from "react-router";
import { useNavigate } from "react-router-dom";
export default function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navRef = useRef();
  const navigate = useNavigate();
  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <nav className="navbar" ref={navRef}>
      <div className="logoContainer">
        <img className="logo" src={Images?.uspLogo} alt="Logo" />
      </div>
      {isMobile && (
        <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      )}
      <ul className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
        <li className="font-bold liHoverEffect">
          <Link to="/">Home</Link>
        </li>

        {/* Product Dropdown */}
        <li className="dropdown liHoverEffect">
          <div
            className="flex font-bold "
            onClick={() => toggleDropdown("product")}
          >
            Product
            <FaChevronDown
              className={`arrow ${openDropdown === "product" ? "rotate" : ""}`}
            />
          </div>
          {openDropdown === "product" && (
            <div className="dropdown-menu show">
              <div className="dropdown-grid">
                <ul className="dropdown-column">
                  <li>
                    <strong>Consumables</strong>
                  </li>
                  <li>
                    <Link to="/product/uspSimacolorFluids">
                      USP SIMACOLOR fluids
                    </Link>
                  </li>
                  <li>
                    <Link to="/product/uspTtoRibbons">USP TTO RIBBONS</Link>
                  </li>
                </ul>
                <ul className="dropdown-column">
                  <li>
                    <strong>CIJ PRINTERS</strong>
                  </li>
                  <li>
                    {" "}
                    <Link to="/product/uspJetStream2">
                      USP JETSTREAM II
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="/product/uspA2120">
                      USP A 2120
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="/product/uspStreamLine4SP">
                      USP STREAMLINE 4SP
                    </Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="/product/uspJetStreamDualHead">
                      USP JETSTREAM II (Dual Head)
                    </Link>{" "}
                  </li>
                </ul>
                <ul className="dropdown-column">
                  <li>
                    <strong>TTO Printers</strong>
                  </li>

                  <li>
                    <Link to="/product/uspTto03s05s">USP TTO 03S & 05S</Link>
                  </li>
                </ul>
                <ul className="dropdown-column">
                  <li>
                    <strong>Hi-Resolution Printers</strong>
                  </li>
                  <li>
                    <Link to="/product/copilot128-256">Copilot 128 & 256</Link>
                  </li>
                  <li>
                    <Link to="/product/copilotMax400">Copilot Max 400</Link>
                  </li>
                  <li>
                    <Link to="/product/copilotMax512iTurbo">
                      COPILOT MAX 512i TURBO
                    </Link>
                  </li>
                  <li>
                    <Link to="/product/copilotMaxTurbo">Copilot MAX turbo</Link>
                  </li>
                  <li>
                    <Link to="/product/copilotMaxlt">Copilot MAX lt</Link>
                  </li>
                  <li>
                    <Link to="/product/copilotGemini">Copilot gemini</Link>
                  </li>
                </ul>
                <ul className="dropdown-column">
                  <li>
                    <strong>LASER CODING SYSTEMS</strong>
                  </li>
                  <li>
                    <Link to="/product/uspCo2Laser">USP CO2 Laser</Link>
                  </li>
                  <li>
                    <Link to="/product/uspFiberLaser">USP Fiber Laser</Link>
                  </li>

                  <li>
                    <Link to="/product/uspUvLaser">USP UV Laser</Link>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </li>
        <li className="dropdown liHoverEffect">
          <div
            className="flex  font-bold"
            onClick={() => toggleDropdown("solutions")}
          >
            Solutions
            <FaChevronDown
              className={`arrow ${
                openDropdown === "solutions" ? "rotate" : ""
              }`}
            />
          </div>
          {openDropdown === "solutions" && (
            <div className="dropdown-menu show">
              <ul className="dropdown-column">
                <li>
                  <strong>Solution</strong>
                </li>
                <li>
                  <Link to="/solutions/byIndustry">By Industry</Link>
                </li>
                <li>
                  <Link to="/solutions/byApplication">By Application</Link>
                </li>
              </ul>
            </div>
          )}
        </li>
        <li className="font-bold liHoverEffect">
          <Link to="/knowUs">Know Us</Link>
        </li>
        <li className="dropdown liHoverEffect">
          <div
            className="flex  font-bold"
            onClick={() => toggleDropdown("services")}
          >
            Services
            <FaChevronDown
              className={`arrow ${openDropdown === "services" ? "rotate" : ""}`}
            />
          </div>
          {openDropdown === "services" && (
            <div className="dropdown-menu show">
              <ul className="dropdown-column">
                <li>
                  <strong>Services</strong>
                </li>
                <li>
                  <Link to="/services/support">Services & support</Link>
                </li>
                <li>
                  <Link to="/services/event">Event</Link>
                </li>
                <li>
                  <Link to="/services/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/services/contactus">Contact Us</Link>
                </li>
              </ul>
            </div>
          )}
        </li>
        <li
          className="navbarLogin"
          onClick={() => {
            sessionStorage.clear();
            navigate("/");
            window.location.reload();
          }}
        >
          Logout
        </li>
      </ul>
    </nav>
  );
}
